module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "users-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-users",
      "md-label": "Пользователи",
      "to": {
        name: 'Users'
      }
    }
  }), _c('md-tab', {
    attrs: {
      "id": "tab-groups",
      "md-label": "Группы",
      "to": {
        name: 'UserGroups'
      }
    }
  }), _c('md-tab', {
    attrs: {
      "id": "tab-modules",
      "md-label": "Права",
      "to": {
        name: 'UserModules'
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05b406d6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/users/views/menu.vue
// module id = 1027
// module chunks = 0